/**
 * ECCO Cookie Consent — Vanilla JS
 * Reemplaza la implementación jQuery de theme.liquid
 */

(function () {
  'use strict';

  function $(selector, context) {
    return (context || document).querySelector(selector);
  }

  function show(el) { if (el) el.style.display = 'flex'; }
  function hide(el) { if (el) el.style.display = 'none'; }

  document.addEventListener('DOMContentLoaded', function () {
    var coiOverlay = document.getElementById('coiOverlay');
    var aceptarTodo = document.getElementById('AceptarTodo');
    var declineButton = document.getElementById('declineButton');

    if (window.localStorage.getItem('politycs') !== 'true') {
      show(coiOverlay);
    }

    if (declineButton) {
      declineButton.addEventListener('click', function (e) {
        e.preventDefault();
        window.localStorage.setItem('politycs', 'true');
        hide(coiOverlay);
      });
    }

    if (aceptarTodo) {
      aceptarTodo.addEventListener('click', function (e) {
        e.preventDefault();
        window.localStorage.setItem('politycs', 'true');
        hide(coiOverlay);
      });
    }
  });

  // Menu drawer scroll overflow
  var hamburg = document.querySelector('.menu-drawer-container');
  if (hamburg) {
    hamburg.addEventListener('click', function () {
      document.querySelector('html').style.overflow =
        hamburg.classList.contains('menu-opening') ? 'hidden' : 'visible';
    });
  }

  // List header accordion (.J_list)
  document.addEventListener('click', function (e) {
    var header = e.target.closest('.list-header');
    if (!header) return;
    var li = header.closest('.J_list');
    if (li) li.classList.toggle('open');
  });

  // Mega menu fullwidth fix (reemplaza el setTimeout con jQuery)
  window.addEventListener('load', function () {
    document.querySelectorAll('.tmenu_submenu_mega_position_fullwidth').forEach(function (col) {
      col.style.width = '90vw';
    });
  });

  // Swatch visibility (reemplaza jQuery #swatch-option1/2)
  window.addEventListener('load', function () {
    setTimeout(function () {
      var sw1 = document.getElementById('swatch-option1');
      if (sw1) sw1.style.display = 'none';

      var sw2 = document.getElementById('swatch-option2');
      if (sw2) sw2.style.display = 'none';

      // Traducción label de talla
      var lang = document.documentElement.lang || '';
      var sizeLabel = lang.startsWith('en') ? 'Size' : 'Talla';
      document.querySelectorAll(
        '#swatch-option3 > div > fieldset > div > div > div > legend > label > span,' +
        '#swatch-option3 > div > fieldset > legend > label > span'
      ).forEach(function (el) {
        el.textContent = sizeLabel;
      });
    }, 1000);
  });

})();
